import React from 'react';

import { MainComponent } from 'components';

function List() {
  return (
    <>
      <MainComponent.Manage />
    </>
  );
}

export default List;
